  const getRelativeTime = (date) => {
      const now = new Date();
      const createdAt = new Date(date);

      const istOffset = 5.5 * 60 * 60 * 1000;
      const createdAtIST = new Date(createdAt.getTime() + istOffset);
  
      const diffInSeconds = Math.floor((now - createdAtIST) / 1000);
      
      const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
      };
      for (const [unit, seconds] of Object.entries(intervals)) {
        const interval = Math.floor(diffInSeconds / seconds);
        if (interval >= 1) {
          return `${interval} ${unit}${interval === 1 ? "" : "s"} ago`;
        }
      }
      return "Just now";
    };
    
    export default getRelativeTime;